module.exports = __webpack_public_path__ + "img/source_sw-item1.92f759b8.png";